export interface ConsoleEntry {
  timestamp: string;
  data: any[];
  type: 'error' | 'warn' | 'debug' | 'info' | 'log';
}
